import { defineConfig as o } from "tinacms";
const r = process.env.HEAD || process.env.VERCEL_GIT_COMMIT_REF || "main", s = o({
  branch: r,
  clientId: "a9ce555c-e461-4dc3-a8b0-2c7d9a74ed2f",
  token: "f48d8fd3d351a36b235dad7661fe0bd8fcbd79b7",
  build: {
    outputFolder: "admin",
    publicFolder: ""
  },
  media: {
    tina: {
      mediaRoot: "images",
      publicFolder: ""
    }
  },
  schema: {
    collections: [{
      name: "post",
      label: "Posts",
      path: "_posts",
      ui: {
        filename: {
          slugify: (e) => {
            var a;
            const t = new Date(), n = t.getDate(), l = t.getMonth() + 1;
            return `${`${t.getFullYear()}-${l}-${n}`}-${(a = e == null ? void 0 : e.title) == null ? void 0 : a.toLowerCase().replace(/ /g, "-")}`;
          }
        }
      },
      fields: [
        {
          type: "string",
          name: "title",
          label: "Title",
          isTitle: !0,
          required: !0
        },
        {
          type: "string",
          name: "author",
          label: "Author",
          required: !0,
          options: [
            {
              value: "Sanna",
              label: "Sanna"
            },
            {
              value: "Sven",
              label: "Sven"
            },
            {
              value: "Svenna",
              label: "Svenna"
            }
          ]
        },
        {
          type: "image",
          name: "featured_image",
          label: "Featured image"
        },
        {
          type: "rich-text",
          name: "body",
          label: "Body",
          isBody: !0
        }
      ]
    }]
  }
});
export {
  s as default
};
